var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.825 25C201.455 25.0014 207.813 27.6363 212.5 32.325L255.175 75C259.864 79.6873 262.499 86.0451 262.5 92.675V200C262.5 206.63 259.866 212.989 255.178 217.678C250.489 222.366 244.13 225 237.5 225H212.5V250C212.5 256.63 209.866 262.989 205.178 267.678C200.489 272.366 194.13 275 187.5 275H75C68.3696 275 62.0107 272.366 57.3223 267.678C52.6339 262.989 50 256.63 50 250V100C50 93.3696 52.6339 87.0107 57.3223 82.3223C62.0107 77.6339 68.3696 75 75 75H100V50C100 43.3696 102.634 37.0107 107.322 32.3223C112.011 27.6339 118.37 25 125 25H194.825ZM100 100H75V250H187.5V225H125C118.37 225 112.011 222.366 107.322 217.678C102.634 212.989 100 206.63 100 200V100ZM175 50H125V200H237.5V112.5H193.75C189.089 112.5 184.595 110.764 181.145 107.63C177.694 104.496 175.535 100.19 175.087 95.55L175 93.75V50ZM200 55.175V87.5H232.325L200 55.175Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.95a4676768b828e1457b2696e3c95218.svg";
export { ForwardRef as ReactComponent };